import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Success status icon — checkmark inside a circle.
 *
 * Dual-tone layered style:
 * - Outer circle: cyan accent fill at 8%, currentColor outline
 * - Inner circle: cyan accent fill at 6% (concentric layer)
 * - Checkmark: currentColor stroke
 *
 * Used for completed / success pipeline states.
 */
export const SuccessIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size} fill="none">
    {/* Outer circle — cyan accent fill at 8% */}
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="#00d4ff"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
    />
    {/* Inner concentric circle — cyan accent fill at 6% */}
    <circle cx="12" cy="12" r="6" fill="#00d4ff" fillOpacity={0.06} />
    {/* Checkmark */}
    <path
      d="M 8 12 L 11 15 L 16 9"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

SuccessIcon.displayName = "SuccessIcon";

export default SuccessIcon;
